
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 4.167h-3.333v-.834c0-1.416-1.084-2.5-2.5-2.5H7.333c-1.416 0-2.5 1.084-2.5 2.5v.834H1.5C1 4.167.667 4.5.667 5c0 .5.333.833.833.833h.833v10.834c0 1.416 1.084 2.5 2.5 2.5h8.334c1.416 0 2.5-1.084 2.5-2.5V5.833h.833c.5 0 .833-.333.833-.833 0-.5-.333-.833-.833-.833zm-10-.834c0-.5.333-.833.833-.833h3.334c.5 0 .833.333.833.833v.834h-5v-.834zM14 16.667c0 .5-.333.833-.833.833H4.833c-.5 0-.833-.333-.833-.833V5.833h10v10.834zm-5.833-7.5v5c0 .5-.334.833-.834.833-.5 0-.833-.333-.833-.833v-5c0-.5.333-.834.833-.834.5 0 .834.334.834.834zm3.333 0v5c0 .5-.333.833-.833.833-.5 0-.834-.333-.834-.833v-5c0-.5.334-.834.834-.834.5 0 .833.334.833.834z","fill":"#363636","fill-rule":"nonzero"}})])
          )
        }
      }
    